import './index.scss';
import CookieManager from 'utils/cookie_manager';
import { Application, Controller } from 'utils/stimulus';

const localStorageKey = `welcomeChecklist.${currentUser.id}`;

const questionPageUrl =
  '/questoes-de-concursos/questoes?has_commentaries=true&has_professor_commentaries=true';

const getInitialChecklist = () => {
  return (
    JSON.parse(window.localStorage.getItem(localStorageKey)) || {
      lastUpdate: null,
      account: {
        title: 'Crie sua conta',
        subtitle: 'Cadastre-se e comece a sua jornada!',
        icon: 'check-circle-solid',
        completed: true,
        link: '#'
      },
      valhalla: {
        title: 'Conheça as Apostilas Digitais',
        subtitle: 'Estude com material em PDF + Aulas',
        icon: 'book',
        completed: false,
        link: '[ils]b/guia-de-estudos/busca/pdf'
      },
      lessons: {
        title: 'Assista a aula de um curso',
        subtitle: 'Conteúdo feito pelos melhores professores',
        icon: 'play-circle',
        completed: false,
        link: '[ils]meu-guia'
      },
      answers: {
        title: 'Responda Questões',
        subtitle: 'Aplique um filtro e comece sua prática!',
        icon: 'list-ul',
        completed: false,
        link: questionPageUrl
      },
      comments: {
        title: 'Veja comentários das questões',
        subtitle: 'Conheça nossa comunidade de alunos',
        icon: 'comments',
        completed: false,
        link: questionPageUrl
      },
      teachers: {
        title: 'Veja os Gabaritos dos professores',
        subtitle: 'Veja comentários dos professores',
        icon: 'graduation-cap',
        completed: false,
        link: questionPageUrl
      }
    }
  );
};

const saveChecklist = checklist => {
  checklist.lastUpdate = new Date().toDateString();

  window.localStorage.setItem(localStorageKey, JSON.stringify(checklist));
};

export const notifyWelcomeChecklist = resource => {
  if (!gon.flags.user_onboarding.active) {
    return;
  }

  const checklist = getInitialChecklist();

  if (checklist[resource].completed) {
    return;
  }

  checklist[resource].completed = true;

  saveChecklist(checklist);
};

export default class WelcomeChecklist extends Controller {
  static targets = [
    'progressBar',
    'message',
    'completedText',
    'tasksContainer'
  ];

  tasks = [];
  lastUpdate = null;
  numberOfStepDone = 0;
  numberOfStepTotal = 0;

  connect() {
    this.getTasks();

    if (this.isOnboardingComplete()) {
      this.element.remove();
      return;
    }

    this.calculateTaskProgress();
    this.render();
  }

  getTasks() {
    const checklist = getInitialChecklist();

    const isIlsLessonComplete =
      CookieManager.getCookie(`${localStorageKey}.lessons`) === 'true';

    const isIlsValhallaComplete =
      CookieManager.getCookie(`${localStorageKey}.valhalla`) === 'true';

    if (!checklist.lessons.completed && isIlsLessonComplete) {
      checklist.lessons.completed = true;
      saveChecklist(checklist);
    }

    if (!checklist.valhalla.completed && isIlsValhallaComplete) {
      checklist.valhalla.completed = true;
      saveChecklist(checklist);
    }

    this.tasks = [
      checklist.account,
      checklist.valhalla,
      checklist.lessons,
      checklist.answers,
      checklist.comments,
      checklist.teachers
    ];

    this.lastUpdate = checklist.lastUpdate;
  }

  isOnboardingComplete() {
    const isAllCompleted = this.tasks.every(task => task.completed);
    const isAnotherDay =
      new Date(this.lastUpdate).getDate() !== new Date().getDate();

    return isAllCompleted && isAnotherDay;
  }

  calculateTaskProgress() {
    this.numberOfStepDone = this.tasks.filter(task => task.completed).length;
    this.numberOfStepTotal = this.tasks.length;
  }

  render() {
    this.renderProgressBar();
    this.renderMessage();
    this.renderCompletedText();
    this.renderTasks();
  }

  renderProgressBar() {
    this.progressBarTarget.style.width = `${
      (100 * this.numberOfStepDone) / this.numberOfStepTotal
    }%`;
  }

  renderMessage() {
    if (this.numberOfStepDone === 1) {
      this.messageTarget.textContent = 'Dê seus primeiros passos!';
    } else {
      this.messageTarget.classList.add('information__message--inprogress');

      this.messageTarget.textContent =
        this.numberOfStepDone === this.numberOfStepTotal
          ? 'Boa, sua jornada começou! Continue estudando!'
          : 'Você está mandando bem!';
    }
  }

  renderCompletedText() {
    this.completedTextTarget.textContent = `${this.numberOfStepDone}/${this.numberOfStepTotal} CONCLUÍDOS`;
  }

  renderTasks() {
    this.tasksContainerTarget.innerHTML = this.tasks
      .map(
        task => `
        <a href="${this.parseLink(task.link)}" class="tasks__item
          ${task.completed ? 'tasks__item--completed' : ''}
          ${task.link === '#' ? 'tasks__item--nolink' : ''}
        ">
          <div class="icon-container">
            <i class="q-icon q-icon-${
              task.completed ? 'check-circle-solid' : task.icon
            }"></i>
          </div>

          <div class="text-container">
            <p class="title">${task.title}</p>
            <p class="subtitle">${task.subtitle}</p>
          </div>
        </a>
        `
      )
      .join('');
  }

  parseLink(link) {
    return link.includes('[ils]')
      ? link.replace('[ils]', this.element.getAttribute('data-ils-path'))
      : link;
  }
}

global.WelcomeChecklistApplication =
  global.WelcomeChecklistApplication || Application.start();
global.WelcomeChecklistApplication.register(
  'welcome-checklist',
  WelcomeChecklist
);
